"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
const Interfaces_1 = require("../Interfaces");
const useMobileTheme = (themeVariant) => {
    const theme = (0, styles_1.useTheme)();
    const mobileTheme = {
        [Interfaces_1.ThemeVariant.dark]: {
            text: 'white',
            divider: '#4f4999',
            backgroundColor: theme.palette.insightful.main,
            item: '#494395',
            itemLeftBorder: 'white',
            iconFilter: 'brightness(0) invert(1)',
        },
        [Interfaces_1.ThemeVariant.light]: {
            text: 'black',
            divider: '#dcdee3',
            backgroundColor: 'white',
            item: theme.palette.grey[200],
            itemLeftBorder: theme.palette.red.main,
            iconFilter: '',
        },
    };
    return mobileTheme[themeVariant];
};
exports.default = useMobileTheme;
